// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.embla-wrapper {
  margin: 0 30px;
}

.embla {
  overflow: hidden;
}

.embla__container {
  display: flex;
  user-select: none;
  -webkit-user-select: none;
  touch-action: pan-y;
}

.embla__slide {
  flex: 0 0 100%;
}

.embla__img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.embla__dots {
  display: flex;
  justify-content: center;
  margin: 10px 0 50px;
}

.embla__dots button {
  width: 12px;
  height: 12px;
  margin: 0 4px;
  border-radius: 50%;
  border: none;
  background-color: #ccc;
  cursor: pointer;
  padding: 0;
  display: inline-block;
  transition: background-color 0.3s ease;
}

.embla__dots button.is-selected {
  background-color: #152935;
}

/* Showcase variant: coverflow stage used by the sign-up page */
/* One source of truth for the geometry: --card-h drives the screenshot height,
   the card width (screenshots are 3000x2500, so exactly 1.2x the height) and
   the slide width. The gap between cards is then a fixed value at every screen
   size, instead of the leftover space inside a percentage-width slide. */
.embla-wrapper--showcase {
  --card-h: 320px;
  --card-gap: 22px;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  font-family: "Public Sans";
  /* Equal-width slides, each centring an identically sized card, with mirrored
     transforms: the gap either side of the active screenshot is the same value
     by construction, on every slide. 3D rotation is deliberately avoided — its
     perspective projection makes the two sides read as different widths. */
  /* No transform at all on the active slide: a scale — even scale(1) — keeps
     the layer composited and resamples the screenshot, which softens the text. */
  /* Whole screenshot, never cropped. Height is bounded by viewport height, by
     slide width (32vw ≈ card width / 1.2) and by an absolute cap, so the card
     matches the image's 6:5 ratio exactly — no letterboxing, no white margin. */
  /* Hover affordance for the lightbox */
}
.embla-wrapper--showcase .embla-wrapper__stage {
  position: relative;
}
.embla-wrapper--showcase .embla {
  overflow: hidden;
  padding: 2px 0 0;
}
.embla-wrapper--showcase .embla__container {
  align-items: center;
}
.embla-wrapper--showcase .embla__slide {
  flex: 0 0 calc(var(--card-h) * 1.2 + var(--card-gap) * 2);
  max-width: 100%;
  min-width: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center center;
  transition: transform 0.55s cubic-bezier(0.32, 0.72, 0, 1), opacity 0.55s ease, filter 0.55s ease;
}
.embla-wrapper--showcase .embla__slide--is-active {
  z-index: 3;
  transform: none;
  opacity: 1;
}
.embla-wrapper--showcase .embla__slide--is-prev,
.embla-wrapper--showcase .embla__slide--is-next {
  z-index: 2;
  opacity: 0.72;
  filter: brightness(0.78);
}
.embla-wrapper--showcase .embla__slide--is-prev {
  transform: scale(0.86) translateX(7%);
}
.embla-wrapper--showcase .embla__slide--is-next {
  transform: scale(0.86) translateX(-7%);
}
.embla-wrapper--showcase .embla__slide--is-far {
  z-index: 1;
  opacity: 0;
  transform: scale(0.76);
}
.embla-wrapper--showcase .embla__img {
  width: auto;
  max-width: 100%;
  height: var(--card-h);
  object-fit: contain;
  object-position: center;
  padding: 0;
  border-radius: 14px;
  background-color: #ffffff;
  box-shadow: 0 22px 48px -22px rgba(0, 0, 0, 0.6);
}
.embla-wrapper--showcase .embla__slide--is-active .embla__img {
  cursor: zoom-in;
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.embla-wrapper--showcase .embla__slide--is-active .embla__img:hover {
  transform: translateY(-2px);
}
.embla-wrapper--showcase .embla__slide--is-active .embla__img {
  box-shadow: 0 32px 72px -24px rgba(0, 0, 0, 0.85);
}
.embla-wrapper--showcase .embla__dots {
  margin: 16px 0 0;
  gap: 8px;
}
.embla-wrapper--showcase .embla__dots button {
  width: 8px;
  height: 8px;
  margin: 0;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.28);
  transition: width 0.25s ease, background-color 0.25s ease;
}
.embla-wrapper--showcase .embla__dots button:hover {
  background-color: rgba(255, 255, 255, 0.55);
}
.embla-wrapper--showcase .embla__dots button.is-selected {
  width: 26px;
  background-color: #ffffff;
}
.embla-wrapper--showcase .embla__caption {
  margin-top: 16px;
  padding: 0 24px;
  text-align: center;
  animation: emblaCaptionIn 0.45s ease both;
}
.embla-wrapper--showcase .embla__caption h3 {
  margin: 0;
  color: #6E9BF2;
  font-family: "Public Sans";
  font-size: clamp(19px, 1.45vw, 23px);
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.3;
}
.embla-wrapper--showcase .embla__caption p {
  margin: 7px auto 0;
  max-width: 680px;
  color: rgba(255, 255, 255, 0.82);
  font-family: "Public Sans";
  font-size: clamp(15px, 1.05vw, 17px);
  font-weight: 400;
  line-height: 1.5;
}

/* Lightbox: full-screen view of a screenshot, since the carousel card always
   shows these 3000x2500 images heavily downscaled. Fits the viewport by
   default; clicking the image switches to native resolution with scrolling. */
.embla__lightbox {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  margin: 0;
  z-index: 2147483000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 28px;
  background-color: rgba(6, 14, 20, 0.88);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
  animation: emblaLightboxIn 0.18s ease both;
  font-family: "Public Sans";
  /* The frame is a flex item, so it shrinks to whatever the column leaves after
     padding, gap and the hint line. It must not clip: the image carries the
     size limits so the whole screenshot always fits. */
}
.embla__lightbox__frame {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  max-width: 96vw;
  max-height: calc(100vh - 118px);
  overflow: visible;
}
.embla__lightbox__frame.is-native {
  overflow: auto;
  border-radius: 12px;
  background-color: #ffffff;
}
.embla__lightbox__img {
  display: block;
  max-width: 96vw;
  max-height: calc(100vh - 118px);
  width: auto;
  height: auto;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0 40px 90px -30px rgba(0, 0, 0, 0.9);
  object-fit: contain;
  cursor: zoom-in;
}
.embla__lightbox__frame.is-native .embla__lightbox__img, .embla__lightbox__frame.is-native .embla__lightbox__img {
  max-width: none;
  max-height: none;
  cursor: zoom-out;
}
.embla__lightbox__close {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 50%;
  background-color: rgba(12, 24, 33, 0.8);
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.embla__lightbox__close:hover {
  background-color: #1B57D1;
  border-color: #1B57D1;
}
.embla__lightbox__close .material-icons {
  font-size: 21px;
  line-height: 1;
}
.embla__lightbox__hint {
  margin: 0;
  color: rgba(255, 255, 255, 0.68);
  font-family: "Public Sans";
  font-size: 13px;
  font-weight: 500;
  text-align: center;
}

@keyframes emblaLightboxIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes emblaCaptionIn {
  0% {
    opacity: 0;
    transform: translateY(6px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Only --card-h changes per breakpoint; card width, slide width and therefore
   the gap all follow from it, so the spacing is identical at every size.
   Whole pixels keep the screenshot off sub-pixel boundaries (which is what
   softens the text). Width tiers first, then height caps. */
@media (min-width: 1100px) {
  .embla-wrapper--showcase {
    --card-h: 370px;
    --card-gap: 24px;
  }
}
@media (min-width: 1280px) {
  .embla-wrapper--showcase {
    --card-h: 440px;
    --card-gap: 26px;
  }
}
@media (min-width: 1600px) {
  .embla-wrapper--showcase {
    --card-h: 540px;
    --card-gap: 28px;
  }
}
@media (min-width: 1900px) {
  .embla-wrapper--showcase {
    --card-h: 600px;
    --card-gap: 30px;
  }
}
@media (max-height: 900px) {
  .embla-wrapper--showcase {
    --card-h: 450px;
  }
}
@media (max-height: 820px) {
  .embla-wrapper--showcase {
    --card-h: 390px;
  }
  .embla-wrapper--showcase .embla__dots {
    margin-top: 12px;
  }
  .embla-wrapper--showcase .embla__caption {
    margin-top: 12px;
  }
}
@media (max-height: 740px) {
  .embla-wrapper--showcase {
    --card-h: 330px;
  }
  .embla-wrapper--showcase .embla__dots {
    margin-top: 10px;
  }
  .embla-wrapper--showcase .embla__caption {
    margin-top: 10px;
  }
  .embla-wrapper--showcase .embla__caption p {
    margin-top: 5px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .embla-wrapper--showcase .embla__slide,
  .embla-wrapper--showcase .embla__caption {
    transition: none;
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Image/LoginIllustration.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;AAEF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,sCAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA,+DAAA;AACA;;;yEAAA;AAIA;EACE,eAAA;EACA,gBAAA;EAEA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;EAeA;;;2EAAA;EAgBA;iFAAA;EA6BA;;gFAAA;EAeA,sCAAA;AAhEF;AATE;EACE,kBAAA;AAWJ;AARE;EACE,gBAAA;EACA,gBAAA;AAUJ;AAPE;EACE,mBAAA;AASJ;AAFE;EACE,yDAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,iGAAA;AAIJ;AACE;EACE,UAAA;EACA,eAAA;EACA,UAAA;AACJ;AAEE;;EAEE,UAAA;EACA,aAAA;EACA,wBAAA;AAAJ;AAGE;EACE,qCAAA;AADJ;AAIE;EACE,sCAAA;AAFJ;AAKE;EACE,UAAA;EACA,UAAA;EACA,sBAAA;AAHJ;AASE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,gDAAA;AAPJ;AAWE;EACE,eAAA;EACA,uDAAA;AATJ;AAWI;EACE,2BAAA;AATN;AAaE;EACE,iDAAA;AAXJ;AAcE;EACE,gBAAA;EACA,QAAA;AAZJ;AAcI;EACE,UAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,2CAAA;EACA,yDAAA;AAZN;AAcM;EACE,2CAAA;AAZR;AAeM;EACE,WAAA;EACA,yBAAA;AAbR;AAkBE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;AAhBJ;AAkBI;EACE,SAAA;EACA,cAAA;EACA,0BAAA;EACA,oCAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAhBN;AAmBI;EACE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;AAjBN;;AAsBA;;8EAAA;AAGA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,uCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,0CAAA;EACA,0BAAA;EAEA;;uDAAA;AAlBF;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;AAnBJ;AAqBI;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAnBN;AAuBE;EACE,cAAA;EACA,eAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gDAAA;EACA,mBAAA;EACA,eAAA;AArBJ;AAwBE;EAEE,eAAA;EACA,gBAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,2CAAA;EACA,kBAAA;EACA,uCAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxBJ;AA0BI;EACE,yBAAA;EACA,qBAAA;AAxBN;AA2BI;EACE,eAAA;EACA,cAAA;AAzBN;AA6BE;EACE,SAAA;EACA,gCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA3BJ;;AA+BA;EACE;IACE,UAAA;EA5BF;EA+BA;IACE,UAAA;EA7BF;AACF;AAgCA;EACE;IACE,UAAA;IACA,0BAAA;EA9BF;EAiCA;IACE,UAAA;IACA,wBAAA;EA/BF;AACF;AAkCA;;;4DAAA;AAIA;EACE;IACE,eAAA;IACA,gBAAA;EAhCF;AACF;AAmCA;EACE;IACE,eAAA;IACA,gBAAA;EAjCF;AACF;AAoCA;EACE;IACE,eAAA;IACA,gBAAA;EAlCF;AACF;AAqCA;EACE;IACE,eAAA;IACA,gBAAA;EAnCF;AACF;AAsCA;EACE;IACE,eAAA;EApCF;AACF;AAuCA;EACE;IACE,eAAA;EArCF;EAuCE;IACE,gBAAA;EArCJ;EAwCE;IACE,gBAAA;EAtCJ;AACF;AA0CA;EACE;IACE,eAAA;EAxCF;EA0CE;IACE,gBAAA;EAxCJ;EA2CE;IACE,gBAAA;EAzCJ;EA2CI;IACE,eAAA;EAzCN;AACF;AA8CA;EAEI;;IAEE,gBAAA;IACA,eAAA;EA7CJ;AACF","sourcesContent":[".embla-wrapper {\n  margin: 0 30px;\n}\n\n.embla {\n  overflow: hidden;\n}\n\n.embla__container {\n  display: flex;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: pan-y;\n}\n\n.embla__slide {\n  flex: 0 0 100%;\n}\n\n.embla__img {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.embla__dots {\n  display: flex;\n  justify-content: center;\n  margin: 10px 0 50px;\n}\n\n.embla__dots button {\n  width: 12px;\n  height: 12px;\n  margin: 0 4px;\n  border-radius: 50%;\n  border: none;\n  background-color: #ccc;\n  cursor: pointer;\n  padding: 0;\n  display: inline-block;\n  transition: background-color 0.3s ease;\n}\n\n.embla__dots button.is-selected {\n  background-color: #152935;\n}\n\n/* Showcase variant: coverflow stage used by the sign-up page */\n/* One source of truth for the geometry: --card-h drives the screenshot height,\n   the card width (screenshots are 3000x2500, so exactly 1.2x the height) and\n   the slide width. The gap between cards is then a fixed value at every screen\n   size, instead of the leftover space inside a percentage-width slide. */\n.embla-wrapper--showcase {\n  --card-h: 320px;\n  --card-gap: 22px;\n\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  font-family: 'Public Sans';\n\n  .embla-wrapper__stage {\n    position: relative;\n  }\n\n  .embla {\n    overflow: hidden;\n    padding: 2px 0 0;\n  }\n\n  .embla__container {\n    align-items: center;\n  }\n\n  /* Equal-width slides, each centring an identically sized card, with mirrored\n     transforms: the gap either side of the active screenshot is the same value\n     by construction, on every slide. 3D rotation is deliberately avoided — its\n     perspective projection makes the two sides read as different widths. */\n  .embla__slide {\n    flex: 0 0 calc(var(--card-h) * 1.2 + var(--card-gap) * 2);\n    max-width: 100%;\n    min-width: 0;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform-origin: center center;\n    transition: transform .55s cubic-bezier(.32, .72, 0, 1), opacity .55s ease, filter .55s ease;\n  }\n\n  /* No transform at all on the active slide: a scale — even scale(1) — keeps\n     the layer composited and resamples the screenshot, which softens the text. */\n  .embla__slide--is-active {\n    z-index: 3;\n    transform: none;\n    opacity: 1;\n  }\n\n  .embla__slide--is-prev,\n  .embla__slide--is-next {\n    z-index: 2;\n    opacity: .72;\n    filter: brightness(.78);\n  }\n\n  .embla__slide--is-prev {\n    transform: scale(.86) translateX(7%);\n  }\n\n  .embla__slide--is-next {\n    transform: scale(.86) translateX(-7%);\n  }\n\n  .embla__slide--is-far {\n    z-index: 1;\n    opacity: 0;\n    transform: scale(.76);\n  }\n\n  /* Whole screenshot, never cropped. Height is bounded by viewport height, by\n     slide width (32vw ≈ card width / 1.2) and by an absolute cap, so the card\n     matches the image's 6:5 ratio exactly — no letterboxing, no white margin. */\n  .embla__img {\n    width: auto;\n    max-width: 100%;\n    height: var(--card-h);\n    object-fit: contain;\n    object-position: center;\n    padding: 0;\n    border-radius: 14px;\n    background-color: #ffffff;\n    box-shadow: 0 22px 48px -22px rgba(0, 0, 0, .6);\n  }\n\n  /* Hover affordance for the lightbox */\n  .embla__slide--is-active .embla__img {\n    cursor: zoom-in;\n    transition: box-shadow .25s ease, transform .25s ease;\n\n    &:hover {\n      transform: translateY(-2px);\n    }\n  }\n\n  .embla__slide--is-active .embla__img {\n    box-shadow: 0 32px 72px -24px rgba(0, 0, 0, .85);\n  }\n\n  .embla__dots {\n    margin: 16px 0 0;\n    gap: 8px;\n\n    button {\n      width: 8px;\n      height: 8px;\n      margin: 0;\n      border-radius: 999px;\n      background-color: rgba(255, 255, 255, .28);\n      transition: width .25s ease, background-color .25s ease;\n\n      &:hover {\n        background-color: rgba(255, 255, 255, .55);\n      }\n\n      &.is-selected {\n        width: 26px;\n        background-color: #ffffff;\n      }\n    }\n  }\n\n  .embla__caption {\n    margin-top: 16px;\n    padding: 0 24px;\n    text-align: center;\n    animation: emblaCaptionIn .45s ease both;\n\n    h3 {\n      margin: 0;\n      color: #6E9BF2;\n      font-family: 'Public Sans';\n      font-size: clamp(19px, 1.45vw, 23px);\n      font-weight: 700;\n      letter-spacing: -.01em;\n      line-height: 1.3;\n    }\n\n    p {\n      margin: 7px auto 0;\n      max-width: 680px;\n      color: rgba(255, 255, 255, .82);\n      font-family: 'Public Sans';\n      font-size: clamp(15px, 1.05vw, 17px);\n      font-weight: 400;\n      line-height: 1.5;\n    }\n  }\n}\n\n/* Lightbox: full-screen view of a screenshot, since the carousel card always\n   shows these 3000x2500 images heavily downscaled. Fits the viewport by\n   default; clicking the image switches to native resolution with scrolling. */\n.embla__lightbox {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  height: 100dvh;\n  margin: 0;\n  z-index: 2147483000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 28px;\n  background-color: rgba(6, 14, 20, .88);\n  backdrop-filter: blur(3px);\n  animation: emblaLightboxIn .18s ease both;\n  font-family: 'Public Sans';\n\n  /* The frame is a flex item, so it shrinks to whatever the column leaves after\n     padding, gap and the hint line. It must not clip: the image carries the\n     size limits so the whole screenshot always fits. */\n  &__frame {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 0;\n    max-width: 96vw;\n    max-height: calc(100vh - 118px);\n    overflow: visible;\n\n    &.is-native {\n      overflow: auto;\n      border-radius: 12px;\n      background-color: #ffffff;\n    }\n  }\n\n  &__img {\n    display: block;\n    max-width: 96vw;\n    max-height: calc(100vh - 118px);\n    width: auto;\n    height: auto;\n    border-radius: 12px;\n    background-color: #ffffff;\n    box-shadow: 0 40px 90px -30px rgba(0, 0, 0, .9);\n    object-fit: contain;\n    cursor: zoom-in;\n  }\n\n  &__frame.is-native &__img,\n  &__frame.is-native .embla__lightbox__img {\n    max-width: none;\n    max-height: none;\n    cursor: zoom-out;\n  }\n\n  &__close {\n    position: absolute;\n    top: 18px;\n    right: 18px;\n    width: 40px;\n    height: 40px;\n    padding: 0;\n    border: 1px solid rgba(255, 255, 255, .24);\n    border-radius: 50%;\n    background-color: rgba(12, 24, 33, .8);\n    color: #ffffff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover {\n      background-color: #1B57D1;\n      border-color: #1B57D1;\n    }\n\n    .material-icons {\n      font-size: 21px;\n      line-height: 1;\n    }\n  }\n\n  &__hint {\n    margin: 0;\n    color: rgba(255, 255, 255, .68);\n    font-family: 'Public Sans';\n    font-size: 13px;\n    font-weight: 500;\n    text-align: center;\n  }\n}\n\n@keyframes emblaLightboxIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes emblaCaptionIn {\n  0% {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Only --card-h changes per breakpoint; card width, slide width and therefore\n   the gap all follow from it, so the spacing is identical at every size.\n   Whole pixels keep the screenshot off sub-pixel boundaries (which is what\n   softens the text). Width tiers first, then height caps. */\n@media (min-width: 1100px) {\n  .embla-wrapper--showcase {\n    --card-h: 370px;\n    --card-gap: 24px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .embla-wrapper--showcase {\n    --card-h: 440px;\n    --card-gap: 26px;\n  }\n}\n\n@media (min-width: 1600px) {\n  .embla-wrapper--showcase {\n    --card-h: 540px;\n    --card-gap: 28px;\n  }\n}\n\n@media (min-width: 1900px) {\n  .embla-wrapper--showcase {\n    --card-h: 600px;\n    --card-gap: 30px;\n  }\n}\n\n@media (max-height: 900px) {\n  .embla-wrapper--showcase {\n    --card-h: 450px;\n  }\n}\n\n@media (max-height: 820px) {\n  .embla-wrapper--showcase {\n    --card-h: 390px;\n\n    .embla__dots {\n      margin-top: 12px;\n    }\n\n    .embla__caption {\n      margin-top: 12px;\n    }\n  }\n}\n\n@media (max-height: 740px) {\n  .embla-wrapper--showcase {\n    --card-h: 330px;\n\n    .embla__dots {\n      margin-top: 10px;\n    }\n\n    .embla__caption {\n      margin-top: 10px;\n\n      p {\n        margin-top: 5px;\n      }\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .embla-wrapper--showcase {\n    .embla__slide,\n    .embla__caption {\n      transition: none;\n      animation: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
